import { ICard } from '@/common/integrations/menhir/employee/card/card.types';
import {
  NewCoverflexCardBackIcon,
  NewCoverflexCardIcon,
} from '@/web/components/Icons';
import { ICardNumberProps } from '@/web/components/Icons/NewCoverflexCardBackIcon/NewCoverflexCardBackIcon';
import { Flex, IconCheck } from '@coverflex-tech/hypernova';
import classnames from 'classnames';
import classNames from 'classnames';
import css from './CardColumn.module.css';

interface IProps {
  card: ICard;
  step: 'pan' | 'pin';
  activation?: ICardNumberProps['activation'];
  isActive?: boolean;
}

export const CardColumn = ({ card, step, activation, isActive }: IProps) => {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      className={css.host}
    >
      <div className={css.content}>
        {step === 'pin' && (
          <div
            className={classnames(css.entry, {
              [css.entryReverse!]: isActive,
            })}
          />
        )}
        <div className={css.cardWrapper}>
          <div
            className={classnames(css.cardElem, {
              [css.cardPin!]: step === 'pin',
              [css.cardPinReverse!]: step === 'pin' && isActive,
              [css.cardPanReverse!]: step === 'pan' && isActive,
            })}
          >
            <div className={css.cardFace}>
              <NewCoverflexCardIcon card={card} className={css.cardSvg} />
            </div>
            <div className={classnames(css.cardFace, css.cardBack)}>
              <NewCoverflexCardBackIcon
                card={{ ...card, panLastDigits: '••••' }}
                className={css.cardSvg}
                activation={isActive ? undefined : activation}
              />
            </div>
          </div>
        </div>
        <div
          className={
            !isActive
              ? css.successBadge
              : classNames(css.successBadge, {
                  [css.pan!]: step === 'pan' && isActive,
                  [css.pin!]: step === 'pin' && isActive,
                })
          }
        >
          <IconCheck />
        </div>
      </div>
    </Flex>
  );
};
